import * as Sentry from '@sentry/react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { ThemeProvider } from 'next-themes'
import '@/styles/globals.css'
import App from '@/App'
import { TooltipProvider } from '@/components/ui/tooltip'
import { queryClient } from '@/lib/query'

// The org's shared "frontend" Sentry project DSN — sibling frontend apps ship
// the same DSN; events are told apart by the serviceId tag. Public by design
// (client DSNs are not secrets); override with VITE_SENTRY_DSN_CLIENT if it moves.
const FRONTEND_SENTRY_DSN =
  'https://328eff6a72e541fcba4ecdad77a7f233@o373343.ingest.us.sentry.io/5530667'

const sentryDsn = (import.meta.env.VITE_SENTRY_DSN_CLIENT as string | undefined) || FRONTEND_SENTRY_DSN
if (import.meta.env.PROD) {
  Sentry.init({
    dsn: sentryDsn,
    release: import.meta.env.VITE_APP_VERSION as string | undefined,
    environment: 'production',
    sendDefaultPii: false,
  })
  Sentry.setTag('serviceId', 'work')
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider attribute="class" storageKey="n3o-work-theme" defaultTheme="system" enableSystem disableTransitionOnChange>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <App />
        </TooltipProvider>
      </QueryClientProvider>
    </ThemeProvider>
  </StrictMode>,
)
